import http from '../../services/http-common';

class UploadFilesService {
    uploadPIPdf(data) {
        // console.log(data.get)
        return http.post(`/TenantContract/Uploadfiles`, data);
      }
      
      getPIPDFFiles(id,companyID) {
        console.log(id)
        return http.get(`/TenantContract/UploadedFiles/${id}/${companyID}`);
      }
      deleteAllPdfByPIID(id,companyID) {
        console.log(companyID)
        return http.get(`/TenantContract/deleteAllUploadedFiles/${id}/${companyID}`);
      }
      deletePDFFilebyPIPDFID(data) {
        console.log(data)
        return http.put(`/TenantContract/deletebyid`,data);
      }
}

export default new UploadFilesService();